import React from 'react';
import type { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type {
  BackgroundImageProps,
  BackgroundPositionProps,
  BackgroundRepeatProps,
} from 'styled-system';
import { backgroundImage, backgroundPosition, backgroundRepeat, space } from 'styled-system';

import arrowRight from 'common/assets/icons/arrow-right-gray.svg';
import Input from 'common/components/Input/StatefulInput';
import type { SpaceProps } from 'common/theme/system-types';
import type { CursorProps, TextOverflowProps } from 'common/theme/system-utilities';
import { cursor, textOverflow } from 'common/theme/system-utilities';

const UnstyledDrawerInput = styled(Input)<
  ComponentProps<typeof Input> &
    SpaceProps &
    BackgroundImageProps &
    BackgroundRepeatProps &
    BackgroundPositionProps &
    CursorProps &
    TextOverflowProps
>`
  ${space}
  ${backgroundImage}
  ${backgroundRepeat}
  ${backgroundPosition}
  ${cursor}
  ${textOverflow};

  caret-color: transparent;

  ${({ hasError }) =>
    hasError &&
    css`
      background-position:
        right 32px top 50%,
        0 0;
    `}
`;

const DrawerInput = (props: ComponentProps<typeof UnstyledDrawerInput>) => (
  <UnstyledDrawerInput
    mb="sp_0"
    pr="sp_24"
    backgroundImage={`url('${arrowRight}')`}
    backgroundRepeat="no-repeat, repeat"
    backgroundPosition="right 8px top 50%, 0 0"
    cursor="pointer"
    textOverflow="ellipsis"
    {...props}
  />
);

export default DrawerInput;
